/**
 * GlucofySplashLoading — shown while auth/session data is still resolving.
 * Deliberately standalone: no AppLayout, no DesktopSidebar, no BottomNav,
 * no skeleton cards. Full-screen, theme-reactive background, centered logo,
 * one line of copy. Never import any app-shell component into this file.
 */
import { useTranslation } from "react-i18next";
import glucofyLogo from "@/assets/glucofy-logo.png";
import s from "./GlucofySplashLoading.module.css";

const GlucofySplashLoading = () => {
  const { t } = useTranslation();
  return (
    <div className={s.splash}>
      <img src={glucofyLogo} alt="Glucofy" className={s.logo} />
      <p className={s.copy}>{t("common.preparing_recipes", "Preparing your recipes...")}</p>
    </div>
  );
};

export default GlucofySplashLoading;
